import {Injectable, inject} from '@angular/core';
import MobileDetect from 'mobile-detect';
import { BehaviorSubject} from 'rxjs';
import {CookieService} from "@/app/services/cookie.service";
import { WINDOW } from '@/app/tokens/window.token';

/**
 * Interface for native mobile application
 */
@Injectable({ providedIn: 'root' })
export class NativeService {

    private nativeLoadSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private readonly window = inject(WINDOW);
    private readonly cookieService = inject(CookieService);

    constructor() {
        if (this.isMobileDevice() && (this.window as any).nsWebViewInterface) {
            (this.window as any).nsWebViewInterface.on('loaded', () => {
                this.nativeLoadSubject.next(true);
            });
            (this.window as any).nsWebViewInterface.emit('webapp_loaded');
        }
    }

    isMobileDevice(): boolean {
        const mobileDetector = new MobileDetect((this.window as any).navigator.userAgent);
        return !!mobileDetector.mobile() || this.cookieService.getCookie('test_mobile') === 'true';
    }

}
